import types from "resources/types";
import { createResourceListQuery } from "queries";

export const jobWorkersQuery = () =>
  createResourceListQuery(types.JOB_WORKERS, {
    url: "/api/v2/job_workers/",
  });
